import React from 'react'
import { useEffect, useState, useRef } from 'react'
import classnames from 'classnames'

export default (props) => {
  const {
    alt,
    title,
    src,
    width,
    height,
    style = {},
    className,
    onError,
    shape,
    errorImgSrc,
    type,
    ...others
  } = props
  const imgRef = useRef()
  const [imgStyles, setImgStyles] = useState({
    display: 'block',
    maxWidth: 'none',
    width: 'auto',
    height: 'auto',
    // transition: 'opacity 0.2s ease',
    opacity: 0,
  })

  const getStyles = (wrapWidth, wrapHeight, imgWidth, imgHeight) => {
    // 进行等比运算
    const wrapRatio = wrapWidth / wrapHeight
    const imgRatio = imgWidth / imgHeight

    let finalWidth = 0
    let finalHeight = 0
    let finalMarginTop = 0
    let finalMarginLeft = 0

    if (wrapRatio > imgRatio) {
      // 父框宽度更大，以父框的宽度为准，拉伸图片上移
      finalWidth = wrapWidth
      finalHeight = finalWidth / imgRatio
      finalMarginTop = ((finalHeight - wrapHeight) / 2) * -1
    } else {
      // 父框高度更大，以父框高度为准，拉伸图片左移动
      finalHeight = wrapHeight
      finalWidth = finalHeight * imgRatio
      finalMarginLeft = ((finalWidth - wrapWidth) / 2) * -1
    }

    return {
      height: finalHeight,
      width: finalWidth,
      marginLeft: finalMarginLeft,
      marginTop: finalMarginTop,
    }
  }

  const imgOnload = () => {
    const imgDOM = imgRef.current
    const { width, height } = props
    const imgWidth = imgDOM.width
    const imgHeight = imgDOM.height

    const imgStyles2 = getStyles(width, height, imgWidth, imgHeight)
    setImgStyles({
      ...imgStyles,
      ...imgStyles2,
      opacity: 1,
    })
  }

  useEffect(() => {
    if (width || height) {
      imgOnload()
    }
  }, [width, height])

  const styles = {
    ...style,
    display: 'inline-block',
    overflow: 'hidden',
    width,
    height,
  }
  if (shape === 'rounded') {
    styles.borderRadius = '5px'
  } else if (shape === 'circle') {
    styles.borderRadius = '50%'
  }

  const cls = classnames('tntd-img', shape, className)

  return (
    <div className={cls} style={styles} {...others}>
      <img
        style={imgStyles}
        onError={onError}
        ref={imgRef}
        src={src}
        alt={alt}
        title={title}
        onLoad={imgOnload}
      />
    </div>
  )
}
